import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute }            from '@angular/router';
import { CardComponent }             from '../../../shared/components/card/card.component';
import { CardTitleComponent }        from '../../../shared/components/card/title/card-title.component';
import { NewHeaderComponent }        from '../../../shared/components/new-header/new-header.component';
import { FooterComponent }           from '../../../shared/components/footer/footer.component';

@Component({
  templateUrl: './sso-session-ended.component.html',
  imports: [CardComponent, CardTitleComponent, NewHeaderComponent, FooterComponent]
})
export class SsoSessionEndedComponent implements OnInit {
  private route = inject(ActivatedRoute);
  isSessionExpired = false

  ngOnInit() {
    this.isSessionExpired = this.route.snapshot.queryParamMap.has('sessionExpired');
  }

}

